import { action, runInAction, makeObservable } from "mobx";
import MensagemStore from "../../store/MensagemStore";
import EstruturaApi from "../api/EstruturaApi";
import { Estrutura } from "../modelo/Estrutura";
import { ITipoMinutaAM } from "../modelo/TipoMinutaAm";
import EstruturaStore from "../stores/EstruturaStore";
import MinutaEdicaoStore from "../stores/MinutaEdicaoStore";

class EstruturaService {
    constructor() {
        makeObservable(this, {
            resetEstruturas: action
        });
    }

    recuperarTodos(): Promise<Estrutura[]> {
        return EstruturaApi.recuperarTodos();
    }

    filtrar(nome: string, tipo: string): Promise<Estrutura[]> {
        const filtro = new Estrutura();
        
        filtro.tipo = ITipoMinutaAM.retornaTipoMinutaAMPelaDescricao(tipo);
        filtro.nome = nome?.length > 0 ? nome : undefined;

        return EstruturaApi.filtrar(filtro);
    }

    async salvar(estrutura: Estrutura) {
        if(!estrutura.nome){
            MensagemStore.apresentarAviso('Favor fornecer nome da estrutura')
            return false;
        }
        if(!estrutura.descricao){
            MensagemStore.apresentarAviso('Favor fornecer uma descrição para a estrutura')
            return false;
        }
        if (estrutura.id) {
            await EstruturaApi.atualizar(estrutura).then(() => {
                runInAction(() => {
                    EstruturaStore.estruturaParaEdicao = undefined;
                });
                MensagemStore.apresentarMensagem('Estrutura atualizado');
            });
        } else {
            await EstruturaApi.salvar(estrutura).then(() => {
                MensagemStore.apresentarMensagem('Estrutura salvo');
            });
        }
        return true;
    }

    excluir(estrutura: Estrutura) {
        return EstruturaApi.excluir(estrutura);
    }

    carregarEstruturas = async () => {
        const estruturas = await this.recuperarTodos();
        runInAction(() => {
            EstruturaStore.estruturas = estruturas;
            EstruturaStore.estruturasFiltradas = estruturas;
        });
    }

    resetEstruturas = () => {
        EstruturaStore.estruturasFiltradas = EstruturaStore.estruturas;
    };

    temEstruturaPadrao = () => {
        if (!MinutaEdicaoStore.estruturaEdicao) {
            MensagemStore.apresentarAviso('Este gabinete não tem uma estrutura padrão. Favor criar uma.');
            return false;
        }
        return true;
    }

    criarEstruturasPadrao = () => {
        return EstruturaApi.criarEstruturasPadrao();
    }
}
export default new EstruturaService();